module.exports = __webpack_public_path__ + "img/no_data.e03ddb20.png";